"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTravelDatesDropdownPosition = void 0;
const react_1 = require("react");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const useTravelDatesDropdownPosition = (isDropdownOpen) => {
    const travelDatesDropdownRef = (0, react_1.useRef)(null);
    const observer = (0, react_1.useRef)();
    (0, libs_hooks_react_1.useBrowserOnlyLayoutEffect)(() => {
        if (typeof window.IntersectionObserver === 'undefined')
            return;
        if (!isDropdownOpen)
            return;
        const travelDatesDropdownEl = travelDatesDropdownRef.current;
        observer.current = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const pxToMove = Math.round(entry.boundingClientRect.right - entry.intersectionRect.right);
                if (travelDatesDropdownEl && pxToMove > 0) {
                    travelDatesDropdownEl.style.transform = `translateX(-${pxToMove}px)`;
                }
            });
        }, { threshold: 1 });
        if (travelDatesDropdownEl) {
            observer.current.observe(travelDatesDropdownEl);
        }
        return () => {
            if (travelDatesDropdownEl && observer.current) {
                observer.current.unobserve(travelDatesDropdownEl);
            }
        };
    }, [isDropdownOpen]);
    return travelDatesDropdownRef;
};
exports.useTravelDatesDropdownPosition = useTravelDatesDropdownPosition;
//# sourceMappingURL=useTravelDatesDropdownPosition.js.map